import {createApp} from 'vue'
import App from './App.vue'
import router from './router/index.js';
import './assets/css/tailwind.css';
import './assets/libs/@mdi/font/css/materialdesignicons.min.css';
import './assets/libs/@iconscout/unicons/css/line.css';
import './assets/libs/tiny-slider/tiny-slider.css';
import 'tiny-slider/dist/tiny-slider.css'
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';

const app = createApp(App);
app.component('Toast', Toast);
app.use(router);
app.use(ToastService);
app.use(PrimeVue, {
    theme: {
        preset: Aura, // Apply the Aura theme
        options: {
            darkModeSelector: false,
        },
    },
})

app.mount('#app');

